// Material Kit 2 React pages
import Videos from "pages/Albums/video";

export default function VideosPage() {
  return <Videos />;
}
